<template>
  <div class="flex flex-col items-center content-center justify-center p-5">
    <div class="w-full max-w-3xl">
      <ExternalBlocked />
    </div>
  </div>
</template>

<script>
import ExternalBlocked from '@/components/ExternalBlocked'

export default {
  name: 'ExternalBlockedView',

  components: {
    ExternalBlocked
  }
}
</script>
